import useFormContext from "../../../hooks/useFormContext"
import React, {useEffect, useMemo, useState} from "react";
import {translate} from "../../../i18n";
import {useDispatch, useSelector} from "react-redux";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import CountrySelect from "../../../ass_components/CountrySelect";
import countryList from "react-select-country-list";
import countries from 'world-countries'
import {endpoints} from "../../../servics/apiEndpoints";

const PersonalInformations = () => {

    const { data, handleChange, errors} = useFormContext()
    const language_code = useSelector(state => state.lang);
    const iso2 = useSelector((s) => s.country.country?.value) || 'TG';
    const countryCode = iso2.toLowerCase();

    // Si data.nationality est string 'TG' (ou vide)
    const nationality = data.nationality || iso2;

    const africanCountryCodes = [
        "DZ","AO","BJ","BW","BF","BI","CM","CV","CF","TD","KM","CD","CG",
        "CI","DJ","EG","GQ","ER","SZ","ET","GA","GM","GH","GN","GW","KE",
        "LS","LR","LY","MG","MW","ML","MR","MU","MA","MZ","NA","NE","NG",
        "RW","ST","SN","SC","SL","SO","ZA","SS","SD","TZ","TG","TN","UG",
        "EH","ZM","ZW"
    ];
    const option = useMemo(() => {
        return countryList()
            .getData()
            .filter((country) => africanCountryCodes.includes(country.value));
    }, []);

    const countryOptions = countries.map((country) => ({
        label: country.name.common,
        value: country.cca2, // 2-letter code
    }))

    // useMemo pour éviter de recalculer à chaque render
    const options = useMemo(() => countryOptions, [])


    // Fetch nearby addresses

    function formatPlace(el) {
        const name = el.tags.name;
        const housenumber = el.tags["addr:housenumber"] || "";
        const street = el.tags["addr:street"] || "";
        const postcode = el.tags["addr:postcode"] || "";
        const city = el.tags["addr:city"] || "";

        // Build a readable address
        let addressParts = [];
        if (housenumber || street) {
            addressParts.push(`${housenumber} ${street}`.trim());
        }
        if (postcode || city) {
            addressParts.push(`${postcode} ${city}`.trim());
        }

        const fullAddress = addressParts.length ? ` — ${addressParts.join(", ")}` : "";

        return {
            id: el.id,
            name: `${name}${fullAddress}`, // Display name in dropdown
            rawName: name,
            distance: el.distance, // Keep distance if calculated earlier
        };
    }

    const [places, setPlaces] = useState([])
    const [loading, setLoading] = useState(true);

    function haversineDistance(lat1, lon1, lat2, lon2) {
        const toRad = (deg) => (deg * Math.PI) / 180;
        const R = 6371; // Earth radius in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) ** 2;

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // km
    }

    async function fetchNearbyPlaces(lat, lon) {
        const overpassQuery = `
            [out:json];
            (
              node["amenity"](around:2000, ${lat}, ${lon});
              node["shop"](around:2000, ${lat}, ${lon});
            );
            out;
          `;

        const query = `
            [out:json];
            (
              node["name"]["shop"]["addr:postcode"](around:2000, ${lat}, ${lon});
              node["name"]["amenity"]["addr:postcode"](around:2000, ${lat}, ${lon});
              node["name"]["shop"]["addr:housenumber"](around:2000, ${lat}, ${lon});
              node["name"]["amenity"]["addr:housenumber"](around:2000, ${lat}, ${lon});
            );
            out;
            `;

        const placesRes = await fetch(
            "https://overpass-api.de/api/interpreter",
            {
                method: "POST",
                body: query,
            }
        );

        const placesData = await placesRes.json();

        return placesData.elements
            .filter((el) => el.tags && el.tags.name)
            .map((el) => {
                const distance = haversineDistance(
                    parseFloat(lat),
                    parseFloat(lon),
                    el.lat,
                    el.lon
                );
                return { ...el, distance };
            })
            .sort((a, b) => a.distance - b.distance)
            .slice(0, 10)
            .map(formatPlace);
    }

    useEffect(() => {
        async function loadPlaces() {
            try {
                const geoRes = await fetch(endpoints.geoInfo);
                if (!geoRes.ok) throw new Error("Erreur API GeoInfo");

                const geoData = await geoRes.json();
                const [lat, lon] = geoData.loc?.split(",") || [];

                if (lat && lon) {
                    const topPlaces = await fetchNearbyPlaces(lat, lon);
                    setPlaces(topPlaces);
                }
            } catch (err) {
                console.error("❌ Erreur :", err);
                setPlaces([]);
            } finally {
                setLoading(false);
            }
        }

        loadPlaces();
    }, []);

    const content = (
        <div className="flex-col">
            <div className="split-container">
                <div className="flex-col">
                    <label htmlFor="firstName">{translate('signup', language_code.lang).firstName}</label>
                    <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        placeholder=""
                        value={data.firstName}
                        onChange={handleChange}
                    />
                    {errors.firstName && <span style={{ color: "red" }}>{errors.firstName}</span>}
                </div>
                <div className="flex-col">
                    <label htmlFor="lastName">{translate('signup', language_code.lang).lastName}</label>
                    <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        placeholder=""
                        value={data.lastName}
                        onChange={handleChange}
                    />
                    {errors.lastName && <span style={{ color: "red" }}>{errors.lastName}</span>}
                </div>
            </div>

            <div className="flex-col">
                <label htmlFor="gender">{translate('signup', language_code.lang).gender.label}</label>
                <select
                    id="gender"
                    name="gender"
                    placeholder="choisir"
                    value={data.gender}
                    onChange={handleChange}
                >
                    <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                    <option value="male">{translate('signup', language_code.lang).gender.male}</option>
                    <option value="female">{translate('signup', language_code.lang).gender.female}</option>
                </select>
                {errors.gender && <span style={{ color: "red" }}>{errors.gender}</span>}
            </div>

            <div className="flex-col">
            <label htmlFor="email">{translate('signup', language_code.lang).email}</label>
            <input
                type="text"
                id="email"
                name="email"
                placeholder="example@yahoo.fr"
                value={data.email}
                onChange={handleChange}
            />
                {errors.email && <span style={{ color: "red" }}>{errors.email}</span>}
            </div>
            <div className="flex-col">
                <label htmlFor="telephone">{translate('signup', language_code.lang).telephone}</label>
                <PhoneInput
                    country={countryCode}
                    value={data.telephone}
                    onChange={(phone) => handleChange("telephone", phone)}
                    inputProps={{
                        name: 'telephone',
                        required: true
                    }}
                />
                {errors.telephone && <span style={{ color: "red" }}>{errors.telephone}</span>}
            </div>
            <div className="flex-col">
            <label htmlFor="heroRepresentantPersonalAddress">{translate('signup', language_code.lang).nationality}</label>
                <CountrySelect
                    value={options.find(opt => opt.value === nationality)}
                    onChange={(selected) => {
                        handleChange({ target: { name: 'nationality', value: selected.value } });
                    }}
                    options={options}
                />
                {errors.nationality && <span style={{ color: "red" }}>{errors.nationality}</span>}
            </div>

            {/*<label htmlFor="heroRepresentantPersonalAddressPlus" className="offscreen">Complement d'adresse</label>*/}
                <div className="flex-col">
            <label htmlFor="nationalIdOrPassport">{translate('signup', language_code.lang).nationalIdOrPassport}</label>
            <input
                type="text"
                id="nationalIdOrPassport"
                name="nationalIdOrPassport"
                placeholder=""
                value={data.nationalIdOrPassport}
                onChange={handleChange}
            />
                    {errors.nationalIdOrPassport && <span style={{ color: "red" }}>{errors.nationalIdOrPassport}</span>}
                </div>
            <div className="flex-col">
            <label htmlFor="companySector">{translate('signup', language_code.lang).additionalAddress}</label>
                <select
                    id="additionalAddress"
                    name="additionalAddress"
                    value={data.additionalAddress}
                    onChange={handleChange}
                    disabled={data.sameAsBilling}
                >
                    <option value="">
                        {translate("signup", language_code.lang).select_placeholder}
                    </option>
                    {loading ? (
                        <option disabled>Chargement des lieux...</option>
                    ) : places?.length ? (
                        places.map((place) => (
                            <option key={place.id} value={place.rawName}>
                                {place.name}
                            </option>
                        ))
                    ) : (
                        <option disabled>📍 Aucun lieu trouvé</option>
                    )}
                </select>
                {errors.additionalAddress && <span style={{ color: "red" }}>{errors.additionalAddress}</span>}
            </div>
                </div>
    )

    return content
}
export default PersonalInformations